import { Save } from "lucide-react";

type RfpQuestionAnswersFooterProps = {
  readonly summaryText: string;
};

export const RfpQuestionAnswersFooter = ({ summaryText }: RfpQuestionAnswersFooterProps) => {
  return (
    <footer className="sticky bottom-0 z-10 border-t border-gray-200 bg-white px-6 py-3">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4">
        <p className="text-sm text-gray-500">{summaryText}</p>
        {/* <button
          type="button"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-white"
        >
          <Save className="h-4 w-4" />
          Save Progress
        </button> */}
      </div>
    </footer>
  );
};
